"use client";

import "./PartnersSwiper.css";

import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay } from "swiper/modules";
import "swiper/css";

import CommonHeading from "../../common-component/common-heading/CommonHeading"; // Update path if needed

const firstRow = [

  "/assets/images/online_mba/recruiters/img2.png",
  "/assets/images/online_mba/recruiters/img3.png",
  // "/assets/online_mba/recruiters/img4.png",
    "/assets/images/online_mba/recruiters/img1.png",
  "/assets/images/online_mba/recruiters/img5.png",
  "/assets/images/online_mba/recruiters/img6.png",
  "/assets/images/online_mba/recruiters/img7.png",
  "/assets/images/online_mba/recruiters/img8.png",
  "/assets/images/online_mba/recruiters/img9.png",
  "/assets/images/online_mba/recruiters/img10.png",
  "/assets/images/online_mba/recruiters/img11.png",
  "/assets/images/online_mba/recruiters/img12.png",
  "/assets/images/online_mba/recruiters/img13.png",
  "/assets/images/online_mba/recruiters/img14.png",
];

export default function PartnersSwiper() {
  return (
    <section className="partners_section">
      <div className="container">
        <div className="row align-items-center">
          {/* Left Content */}
          <div className="col-lg-4 col-md-12 mb-4 mb-lg-0">
            <CommonHeading subTitle="Built Your Career" title="With " />
          </div>

          {/* Right Swipers */}
          <div className="col-lg-8 col-md-12">
            <Swiper
              modules={[Autoplay]}
              slidesPerView={5}
              spaceBetween={50}
              loop={true}
              speed={3500}
              autoplay={{
                delay: 0,
                disableOnInteraction: false,
                reverseDirection: true,
              }}
              allowTouchMove={false}
              className="second_swiper"
              breakpoints={{
                320: {
                  slidesPerView: 2,
                },
                576: {
                  slidesPerView: 2,
                },
                768: {
                  slidesPerView: 4,
                },
                992: {
                  slidesPerView: 3,
                },
                1200: {
                  slidesPerView: 3,
                },
              }}
            ></Swiper>

            <Swiper
              modules={[Autoplay]}
              slidesPerView={6}
              spaceBetween={50}
              loop={true}
              speed={3500}
              autoplay={{
                delay: 0,
                disableOnInteraction: false,
                reverseDirection: true,
              }}
              allowTouchMove={false}
              className="second_swiper"
              breakpoints={{
                320: {
                  slidesPerView: 2,
                },
                576: {
                  slidesPerView: 2,
                },
                768: {
                  slidesPerView: 3,
                },
                1200: {
                  slidesPerView: 4,
                },
              }}
            >
              {firstRow.map((logo, index) => (
                <SwiperSlide key={`second-${index}`}>
                  <div className="partner_logo">
                    <img src={logo} alt={`Partner ${index + 1}`} />
                  </div>
                </SwiperSlide>
              ))}
            </Swiper>
          </div>
        </div>
      </div>
    </section>
  );
}
